export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_FOR_USERNAME = 'FORGOT_PASSWORD_FOR_USERNAME';
